import { BsPeople } from "react-icons/bs";
import { Link } from "react-router-dom";
import "./handover/ClassroomHandoverShell.css";
import "./handover/HandoverMyClasses.css";

function ClassAccessFlowPreview() {
  return (
    <main className="classroom-handover-page vh-100 pt-4">
      <div className="handover-my-classes">
        <header className="handover-my-classes-header">
          <h1>Classes</h1>
          <p>View and set up classes for the 26/27 school year.</p>
        </header>

        <div className="handover-header-controls">
          <label className="handover-progression-filter">
            School Year
            <select defaultValue="26-27" aria-label="School Year">
              <option value="26-27">26/27</option>
            </select>
          </label>
          <label className="handover-progression-filter">
            Grade Level
            <select defaultValue="grade2" aria-label="Grade Level">
              <option value="grade2">Senior Infants</option>
            </select>
          </label>
        </div>

        <section>
          <h2>School Classrooms</h2>
          <div className="handover-owned-grid">
            <Link className="handover-owned-classroom" to="/dev/class-access-message">
              <img
                className="handover-class-illustration"
                src="/assets/imgs/Asset-class.webp"
                alt=""
              />
              <div>
                <p className="handover-progressed-label">(26-27) Senior Infants</p>
                <p className="handover-child-summary">
                  <BsPeople aria-hidden="true" /> School classroom
                </p>
              </div>
              <span className="handover-go-button">
                Go to this class <span aria-hidden="true">›</span>
              </span>
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
}

export default ClassAccessFlowPreview;
